export default function ContactIntro() {
  const audiences = [
    { icon: "ri-user-star-line", label: "African Diaspora Professionals" },
    { icon: "ri-seedling-line", label: "Emerging Investors" },
    { icon: "ri-briefcase-4-line", label: "Entrepreneurs & Founders" },
    { icon: "ri-home-heart-line", label: "Families & Family Offices" },
    { icon: "ri-building-2-line", label: "Institutions & Organizations" },
    { icon: "ri-shake-hands-line", label: "Strategic Partners" },
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
              <span className="w-8 h-px bg-[#C9A961]" />
              Who We Welcome
            </span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
              A Platform Built for Meaningful Connection
            </h2>
            <p className="text-[#6B6B6B] text-base leading-relaxed mb-5">
              Harambee Global Ventures welcomes inquiries from a wide range of individuals and organizations. Whether you are an African Diaspora professional seeking trusted financial guidance, an institution exploring collaboration, or an entrepreneur building cross-border opportunity — we are here to engage.
            </p>
            <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
              Every conversation begins with listening. We take the time to understand your goals, your context, and how Harambee can best serve your journey toward long-term financial clarity and opportunity.
            </p>
            <div className="flex items-center gap-4 p-5 rounded-lg bg-[#F8F6F3] border border-[#E8E4DC]">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0">
                <i className="ri-time-line text-[#1A4D3C] text-xl" />
              </div>
              <div>
                <div className="font-semibold text-[#2B2D2F] text-sm mb-0.5">Response Within 2–3 Business Days</div>
                <div className="text-[#6B6B6B] text-xs leading-relaxed">All inquiries are reviewed personally by our team. We are committed to thoughtful, timely responses.</div>
              </div>
            </div>
          </div>

          <div>
            <div className="grid grid-cols-2 gap-4">
              {audiences.map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-3 p-4 rounded-lg bg-[#F8F6F3] border border-[#E8E4DC] hover:border-[#C9A961]/40 transition-colors"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 flex-shrink-0">
                    <i className={`${item.icon} text-[#1A4D3C] text-base`} />
                  </div>
                  <span className="text-[#2B2D2F] text-sm font-medium leading-snug">{item.label}</span>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-lg overflow-hidden">
              <img
                src="/assets/images/site/contact-intro-001-600x320.jpg"
                alt="Harambee Global Ventures welcoming diverse professionals"
                className="w-full h-[220px] object-cover object-top rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
